module.exports = __webpack_public_path__ + "static/media/vico-c-en-honor-a-la-verdad-edicion-especial-frontal-394x394.c8eb23b6.jpg";